<template>
  <div class="text-xs-center">
    <v-dialog
      scrollable
      v-model="dialog"
      width="800">
      <v-card>
        <v-card-title primary-title>
          <v-layout wrap>
            <v-flex class="headline" sm6 xs12>
              Dettaglio comanda
            </v-flex>
            <v-flex style="line-height: 32px" class="text-xs-right" sm6 xs12>
              num.
              <span class="primary--text">
                {{ $get(currentRow, 'numero_comanda', 'X') }}
              </span>
              del
              <span class="primary--text">{{ $get(currentRow, 'data_ora') | date}}</span>
            </v-flex>
            <v-flex xs12>
              Operatore: <span class="primary--text">{{ $get(currentRow, 'cameriere') }}</span>
            </v-flex>
            <v-flex xs12>
              Sala: <span class="primary--text">{{ $get(currentRow, 'nome_sala') }}</span>
            </v-flex>
            <v-flex xs12>
              Tavolo: <span class="primary--text">{{ $get(currentRow, 'nome_tavolo') }}</span>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text>
          <v-data-table
            disable-initial-sort
            hide-actions
            :loading="loading"
            :headers="headers"
            :items="$get(this.details, 'articoli', [])">
            <template v-slot:items="props">
              <tr v-if="props.item.livello === 0">
                <td v-if="mostraCodiciArticolo">
                  {{ props.item.cod_articolo }}
                </td>
                <td>
                  {{ props.item.descrizione }}
                </td>
                <td class="text-xs-right">
                  {{ props.item.quantita }}
                </td>
                <td class="text-xs-right">
                  {{ props.item.prezzo_base | currency }}
                </td>
                <td class="text-xs-right">
                  {{ props.item.prezzo | currency }}
                </td>
              </tr>
              <tr v-else>
                <td v-if="mostraCodiciArticolo">
                  {{ props.item.cod_articolo }}
                </td>
                <td>
                  <span class="caption" style="padding-left: 16px">
                    {{ props.item.descrizione }}
                  </span>
                </td>
                <td class="text-xs-right">
                  {{ props.item.quantita }}
                </td>
                <td colspan="2"></td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <table>
                <tr class="variante" v-for="variante in props.item.varianti" :key="variante.id">
                  <td v-if="mostraCodiciArticolo">{{ variante.cod_articolo }}</td>
                  <td>{{ variante.descrizione }}</td>
                  <td colspan="3"></td>
                </tr>
              </table>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import stats from '@/mixins/stats';

export default {
  name: 'row-detail',
  mixins: [stats],
  data: () => ({
    dialog: false,
    currentRow: null,
    details: null,
    loading: false,
  }),
  methods: {
    async show(row) {
      this.currentRow = row;
      this.details = null;
      this.loading = true;
      this.dialog = true;
      const details = await this.loadRowDetailComanda([row.locale, row.id_comanda]);
      this.loading = false;
      if (details) {
        this.details = { ...details };
      }
    },
  },
  computed: {
    headers() {
      return [...(this.mostraCodiciArticolo ? [{
        text: 'Cod. articolo',
        value: 'cod_articolo',
        sortable: false,
      }] : []), {
        text: 'Descrizione',
        value: 'descrizione',
        sortable: false,
      }, {
        text: 'Quantità',
        value: 'quantita',
        align: 'right',
        sortable: false,
      }, {
        text: 'Prezzo unitario',
        value: 'prezzo_base',
        align: 'right',
        sortable: false,
      }, {
        text: 'Prezzo',
        value: 'prezzo',
        align: 'right',
        sortable: false,
      }];
    },
  },
};
</script>

<style lang="stylus" scoped>
div >>> .v-card__text
  padding 0
</style>
